import * as yup from "yup";

const contactFormSchema = yup.object().shape({
    contactType: yup
        .string()
        .required("What can we help you with?")
        .oneOf(["new", "existing"], "What can we help you with?"),
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    email: yup.string().required("Email is required").email("Email is invalid"),
    confirmEmail: yup
        .string()
        .required("Email is required")
        .email("Email is invalid")
        .oneOf([yup.ref("email")], "Email does not match"),
    teamName: yup.string().required("Team Name is required"),
    comment: yup.string(),
    ageLevel: yup
        .object()
        .shape({
            value: yup.number().required(),
            label: yup.string().required("Please select an age level"),
        })
        .nullable(),
    recaptcha: yup.string().nullable(),
});

export default contactFormSchema;
